import { createClient } from '@supabase/supabase-js'

// Project ID and Anon Key for 1688Euro
const SUPABASE_URL = 'https://fffljhidmgmoptssitzj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmZmxqaGlkbWdtb3B0c3NpdHpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEwNTMzODMsImV4cCI6MjA3NjYyOTM4M30.hCKIU8-ckFq-CPLepm5ILdeTKBrJz9xLpCBnqGY37p4'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables')
}

// Create and export the Supabase client
export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})